// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"601":"9585aa5e","677":"51980049"}[chunkId] + ".chunk.js";
};